/* PrettyBundles v4 : aides à l'achat sur la fiche produit */
(function () {
  function ready(f) { if (document.readyState !== 'loading') f(); else document.addEventListener('DOMContentLoaded', f); }
  var TRUCK = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/></svg>';

  var LG = [[12, 30, 'aux épaules', 98], [18, 46, 'milieu du dos, au niveau du soutien-gorge', 150], [20, 51, 'bas du milieu du dos', 166], [22, 56, 'juste au-dessus de la taille', 182], [24, 61, 'à la taille', 198], [26, 66, 'sous la taille, haut des hanches', 214]];
  function curlyHair(L) {
    function hw(y) {
      if (y < 34) return 16 + (y - 8) / 26 * 22;
      if (y < 92) return 38 + (y - 34) / 58 * 22;
      return 60;
    }
    var R = [], Lf = [], y;
    for (y = 40; y <= L - 8; y += 2) {
      var rp = Math.min(1, Math.max(0, (y - 40) / 22)), wv = rp * 4.5 * Math.sin(y / 7);
      R.push([120 + hw(y) + wv, y]); Lf.push([120 - hw(y) - rp * 4.5 * Math.sin(y / 7 + 1.3), y]);
    }
    var d = 'M120 6 C146 6 ' + (R[0][0] - 2).toFixed(1) + ' 20 ' + R[0][0].toFixed(1) + ' ' + R[0][1];
    R.forEach(function (p) { d += ' L' + p[0].toFixed(1) + ' ' + p[1]; });
    // pointes : grosses boucles arrondies
    var bw = hw(L), n = 5, i;
    var xs = [];
    for (i = 0; i <= n; i++) xs.push(120 + bw - i * (2 * bw) / n);
    for (i = 1; i <= n; i++) {
      var x0 = xs[i - 1], x1 = xs[i], dep = 9 + (i % 2) * 4;
      d += ' C' + x0.toFixed(1) + ' ' + (L + dep) + ' ' + x1.toFixed(1) + ' ' + (L + dep) + ' ' + x1.toFixed(1) + ' ' + (L - 4);
    }
    Lf.reverse().forEach(function (p) { d += ' L' + p[0].toFixed(1) + ' ' + p[1]; });
    var lx = Lf[Lf.length - 1][0]; d += ' C' + (lx + 2).toFixed(1) + ' 20 94 6 120 6 Z';
    var h = '<path fill="url(#pbHr)" d="' + d + '"/>';
    // spires (anglaises) : courbes bouclées type trochoïde
    h += '<g fill="none" stroke="#A7836E" stroke-opacity=".42" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">';
    [[84, 50, 5], [101, 28, 5.8], [120, 22, 4.8], [139, 28, 5.6], [156, 50, 5]].forEach(function (c, j) {
      var x0 = c[0], y0 = c[1], r = c[2], a = 1.9, s = 'M', t;
      for (t = 0; y0 + a * t < L - 2; t += 0.35) {
        var xx = x0 + r * Math.sin(t + j), yy = y0 + a * t - r * Math.cos(t + j);
        if (Math.abs(xx - 120) > hw(yy) - 3) { s += ''; }
        s += xx.toFixed(1) + ' ' + yy.toFixed(1) + ' L';
      }
      h += '<path d="' + s.slice(0, -2) + '"/>';
    });
    return h + '</g>';
  }
  function lgSvg(len, curly) {
      var row = LG.filter(function (r) { return r[0] === len; })[0] || LG[2];
      var L0 = row[3], L = curly ? Math.max(L0 - 20, 80) : L0, c = Math.max(L - 44, 100);
      var h = '<svg viewBox="0 0 330 300" role="img" aria-label="Longueur ' + len + ' pouces" xmlns="http://www.w3.org/2000/svg">' +
        '<defs><linearGradient id="pbSk" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#EAD3C2"/><stop offset="1" stop-color="#D9BBA6"/></linearGradient>' +
        '<linearGradient id="pbSt" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#CDB39E"/><stop offset=".6" stop-color="#B89C86"/><stop offset="1" stop-color="#A68973"/></linearGradient>' +
        '<linearGradient id="pbHr" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#4B362D"/><stop offset=".5" stop-color="#2A1C17"/><stop offset="1" stop-color="#160F0C"/></linearGradient></defs>';
      h += '<path fill="url(#pbSk)" d="M112 60 L128 60 C129 72 132 78 140 82 C152 87 164 88 169 98 C172 106 170 116 162 124 C158 140 156 160 152 182 C150 194 149 200 150 208 C156 222 164 236 166 256 C168 272 167 288 166 300 L74 300 C73 288 72 272 74 256 C76 236 84 222 90 208 C91 200 90 194 88 182 C84 160 82 140 78 124 C70 116 68 106 71 98 C76 88 88 87 100 82 C108 78 111 72 112 60 Z"/>';
      h += '<path fill="url(#pbSk)" d="M71 98 C64 104 60 120 58 140 C56 162 54 184 55 204 C56 220 56 236 58 250 C59 258 66 258 66 250 C66 234 66 218 67 204 C68 186 70 166 74 146 C76 134 78 124 80 116 Z"/>';
      h += '<path fill="url(#pbSk)" d="M169 98 C176 104 180 120 182 140 C184 162 186 184 185 204 C184 220 184 236 182 250 C181 258 174 258 174 250 C174 234 174 218 173 204 C172 186 170 166 166 146 C164 134 162 124 160 116 Z"/>';
      /* jupe taille haute, satinée */
      h += '<path fill="url(#pbSt)" d="M89 204 C108 209 132 209 151 204 C158 226 166 252 170 300 L70 300 C74 252 82 226 89 204 Z"/>';
      h += '<path d="M89 204 C108 209 132 209 151 204" stroke="#9C806B" stroke-width="1.4" fill="none"/>';
      h += '<path d="M120 212 C119 240 118 270 118 300" stroke="#ffffff" stroke-opacity=".18" stroke-width="3" fill="none"/>';
      h += '<ellipse cx="120" cy="36" rx="21" ry="26" fill="url(#pbSk)"/>';
      if (curly) {
        h += curlyHair(L);
      } else {
        h += '<path fill="url(#pbHr)" d="M120 6 C141 6 151 20 150 40 C150 58 156 72 164 84 C172 96 172 ' + c + ' 168 ' + (L - 12) + ' C164 ' + (L + 1) + ' 152 ' + (L + 2) + ' 140 ' + (L - 4) + ' C131 ' + (L + 3) + ' 109 ' + (L + 3) + ' 100 ' + (L - 4) + ' C88 ' + (L + 2) + ' 76 ' + (L + 1) + ' 72 ' + (L - 12) + ' C68 ' + c + ' 68 96 76 84 C84 72 90 58 90 40 C89 20 99 6 120 6 Z"/>';
        h += '<path d="M120 7 C120 16 120 24 120 30" stroke="#6B5246" stroke-width="1.2" fill="none" stroke-linecap="round"/>';
        [[102, 92], [112, 106], [128, 134], [138, 148]].forEach(function (k) {
          h += '<path d="M' + k[0] + ' 22 C' + (k[0] - 6) + ' 70 ' + (k[1] + 4) + ' ' + (L - 40) + ' ' + k[1] + ' ' + (L - 6) + '" stroke="#ffffff" stroke-opacity=".08" stroke-width="2" fill="none"/>';
        });
      }
      LG.forEach(function (r) {
        var on = r[0] === len;
        h += '<line x1="40" x2="206" y1="' + r[3] + '" y2="' + r[3] + '" stroke="' + (on ? '#8A5A50' : '#D9CBBF') + '" stroke-width="' + (on ? 2 : 1) + '"' + (on ? '' : ' stroke-dasharray="3 4"') + '/>';
        if (on) h += '<circle cx="206" cy="' + r[3] + '" r="3.5" fill="#8A5A50"/>';
        h += '<text x="216" y="' + (r[3] + 4) + '" font-size="' + (on ? 14 : 12) + '" font-weight="' + (on ? 700 : 400) + '" fill="' + (on ? '#141010' : '#8A8079') + '" font-family="DM Sans, sans-serif">' + r[0] + '" · ' + r[1] + ' cm</text>';
      });
      return h + '</svg>';
  }
  ready(function () {
    var pdp = document.querySelector('[data-pb-pdp]');
    if (!pdp) return;
    var on = pdp.querySelector('.pb-range a.is-on');
    var title = (pdp.querySelector('.pb-info__title') || {}).textContent || '';
    var isVirgin = on ? /virgin/i.test(on.textContent) : /virgin|burmese|pixie/i.test(title);
    var isCurly = /curly|boucl|water|deep|kinky/i.test(title + ' ' + ((pdp.querySelector('.pb-tex__i.is-on') || {}).textContent || ''));

    /* 0. Petites légendes sur les photos (texte du alt avant « — ») */
    pdp.querySelectorAll('.pb-gallery__slide img').forEach(function (img) {
      var a = img.getAttribute('alt') || '', i = a.indexOf(' — ');
      if (i > 0 && !img.parentNode.querySelector('.pb-cap')) {
        var c = document.createElement('span');
        c.className = 'pb-cap';
        c.textContent = a.slice(0, i);
        img.parentNode.appendChild(c);
      }
    });

    /* 1. Délai visible tout de suite, sous le prix */
    var price = pdp.querySelector('.pb-price');
    if (price && !pdp.querySelector('.pb-dl')) {
      var dl = document.createElement('p');
      dl.className = 'pb-dl';
      dl.innerHTML = TRUCK + '<span>' + (isVirgin ? '<b>Expédiée sous 72 h</b> · livrée en 7 à 12 jours ouvrés' : '<b>Lavée à la main</b> · livrée en 9 à 15 jours ouvrés') + ', avec suivi</span>';
      price.appendChild(dl);
    }

    /* 2. Aide format + guide des longueurs */
    pdp.querySelectorAll('.pb-opt').forEach(function (fs) {
      var lg = fs.querySelector('legend');
      var name = lg ? lg.textContent : '';
      if (/format/i.test(name) && !fs.querySelector('.pb-help')) {
        var h = document.createElement('p');
        h.className = 'pb-help';
        h.innerHTML = '<b>3 bundles</b> : une pose complète · <b>4 bundles</b> : plus de volume, conseillé dès 26"';
        fs.appendChild(h);
      }
      if (/longueur|taille/i.test(name) && !fs.querySelector('.pb-lg')) {
        var d = document.createElement('details');
        d.className = 'pb-lg';
        d.innerHTML = '<summary>Quelle longueur choisir ?</summary><div class="pb-lg__in"><div class="pb-lg__fig" data-lg-fig></div><p class="pb-lg__cap" data-lg-cap></p><p class="pb-lg__n">' + (isCurly ? 'Les boucles remontent : elles tombent 5 à 10 cm plus haut qu\'une fois lissées. ' : '') + 'Pour une taille moyenne (1,65 m). Un doute ? Écris-nous, on te conseille.</p></div>';
        fs.appendChild(d);
        var fig = d.querySelector('[data-lg-fig]'), cap = d.querySelector('[data-lg-cap]');
        var update = function () {
          var lab = fs.querySelector('[data-option-label]');
          var nums = ((lab ? lab.textContent : '').match(/\d+/g) || []).map(Number).filter(function (n) { return n >= 10 && n <= 40; });
          var len = nums.length ? Math.max.apply(null, nums) : 20;
          fig.innerHTML = lgSvg(len, isCurly);
          var row = LG.filter(function (r) { return r[0] === len; })[0] || LG[2];
          cap.innerHTML = '<b>' + len + '" · ' + row[1] + ' cm</b> : ' + row[2];
        };
        update();
        pdp.addEventListener('click', function (e) { if (e.target.closest('.pb-pill')) setTimeout(update, 30); });
      }
    });

    /* 3. Avis « dans le temps » : un avis par écran, on glisse pour le suivant */
    var buy = pdp.querySelector('.pb-buy');
    if (buy && !pdp.querySelector('.pb-mini-rv')) {
      var Q = [
        ['À sa 2e pose', 'Je suis à ma deuxième pose et franchement ça n\'a pas bougé. Je suis satisfaite malgré que j\'utilise de la chaleur souvent.'],
        ['Après le lavage', 'J\'ai lavé mes cheveux hier, j\'ai perdu 2 cheveux à tout casser. Ils sont incroyables, ce matin voire plus épais.'],
        ['Après plusieurs coiffages', 'Très satisfaite, un petit coup de peigne et c\'est bon. Toujours brillant en plus.']
      ];
      var AV = '<svg viewBox="0 0 40 40" aria-hidden="true"><circle cx="20" cy="20" r="20" fill="#EADBCB"/><circle cx="20" cy="16" r="6.5" fill="#B08C76"/><path d="M8 34c2-7 7-10 12-10s10 3 12 10" fill="#B08C76"/><path d="M13 15c0-6 3-9 7-9s7 3 7 9c1 5 2 9 4 12-3 0-5-1-6-3" fill="#3A2A23"/><path d="M27 15c0-6-3-9-7-9s-7 3-7 9c-1 5-2 9-4 12 3 0 5-1 6-3" fill="#3A2A23"/></svg>';
      var CK = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#1C1615"/><path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#fff" stroke-width="2"/></svg>';
      var box = document.createElement('div');
      box.className = 'pb-mini-rv';
      var html = '<p class="pb-mini-rv__t">Des mois après, elles en parlent</p><div class="pb-mini-rv__track" data-rv-track>';
      Q.forEach(function (q) {
        html += '<figure class="pb-mini-rv__s"><div class="pb-mini-rv__who">' + AV + '<span class="pb-mini-rv__id"><b>Cliente vérifiée ' + CK + '</b><small>' + q[0] + ' · reçu sur Instagram</small></span></div><blockquote class="pb-mini-rv__q">« ' + q[1] + ' »</blockquote></figure>';
      });
      html += '</div><div class="pb-mini-rv__foot"><span class="pb-mini-rv__dots" data-rv-dots>' + Q.map(function (q, i) { return '<i' + (i ? '' : ' class="is-on"') + '></i>'; }).join('') + '</span><a class="pb-mini-rv__a" href="#avis">Tous les avis</a></div>';
      box.innerHTML = html;
      buy.insertAdjacentElement('afterend', box);
      var tr = box.querySelector('[data-rv-track]'), dots = box.querySelectorAll('[data-rv-dots] i');
      tr.addEventListener('scroll', function () {
        var i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }, { passive: true });
    }
  });
})();
